export default "__VITE_ASSET__CaLvSffX__"